// extracted by mini-css-extract-plugin
export default {"button":"Blog_button__t69GF"};